import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionvalidateService } from 'src/app/Services/sessionvalidate.service';
import { EmployeeloginService } from 'src/app/Services/employeelogin.service';
import { UserData, EmployeeData } from 'src/app/Models/employee-and-user-data';
import * as moment from 'moment';
import { CurrentDateComponent } from '../current-date/current-date.component';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { TripContextService } from 'src/app/Services/trip-context.service';


@Component({
  selector: 'app-portal-page',
  templateUrl: './portal-page.component.html',
  styleUrls: ['./portal-page.component.css'],
  providers: [SessionvalidateService],
})
export class PortalPageComponent implements OnInit {
  @Input() inputdate: string | undefined;

  CurrentDate: any;

  currentdate: string | undefined;
  CurrentTime: string | undefined;
  pagemask: boolean | undefined;

  userdata?: UserData;
  shipname = '';
  validsession: boolean | undefined;
  LoginData: any;
  employeeData?: EmployeeData;
  shpId: number | undefined;
  rebcode: string | undefined; 
  somshpID: number | undefined; 
  evtcode: string | undefined; 
  cruiseBeg: Date | string | undefined;
  cruiseEnd: Date | string | undefined;
  pckgBeg: Date | string | undefined;
  pckgEnd: Date | string | undefined;

  /**
   * Mirrors `AppConfigService.showPointsOfInterest`.
   *
   * To show the Points of Interest button: set `"showPointsOfInterest": true` in the
   * deployed `/assets/config.json` (see `showPointsOfInterest` getter on AppConfigService).
   */
  showPointsOfInterest = false;

  constructor(
    private sesssionvalidator: SessionvalidateService,
    private router: Router,
    private EmployeeLoginService: EmployeeloginService,
    private appConfigService: AppConfigService,
    private tripContextService: TripContextService,
  ) {
    this.validsession = this.sesssionvalidator.validate();
    if (this.validsession) {
      this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
      this.shipname = this.userdata?.ShipName!;
    } else {
      this.router.navigate(['/login']);
    }
  }

  ngOnInit(): void {
    this.employeeData = JSON.parse(localStorage.getItem('eeinfo') || '{}');
    if (this.employeeData?.EmployeeNo != undefined) {
      this.checkLogin();
    } else {
      this.validsession = this.sesssionvalidator.validate();
      if (this.validsession) {
        this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
        this.shpId = this.userdata?.shipid!;
        this.shipname = this.userdata?.ShipName!;
      } else {
        this.router.navigate(['/login']);
      }
    }
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.rebcode = this.userdata?.rebcode;
    this.shipname = this.userdata?.ShipName!;
    this.somshpID = this.userdata?.shipid!;
    this.evtcode = this.userdata?.evtcode!;
    this.cruiseBeg = this.userdata?.cruiseBeg;
    this.cruiseEnd = this.userdata?.cruiseEnd;
    this.pckgBeg = this.userdata?.pckgBeg;
    this.pckgEnd = this.userdata?.pckgEnd;

    if (this.inputdate == '')
      this.CurrentDate = moment().format();
    else this.CurrentDate = moment(this.inputdate).format();
    this.CruiseDuration();
    this.Day3();
    this.Day2();

    this.pagemask = this.tripContextService.resolve(this.userdata).pagemask;

    // POI visibility: wired from AppConfigService (see getter comment).
    this.showPointsOfInterest = this.appConfigService.showPointsOfInterest;
  }

  checkLogin() {
    this.LoginData = this.EmployeeLoginService.GetEmployeeLogin(
      this.employeeData?.EmployeeNo,
      this.employeeData?.LastName
    ).subscribe((LoginData) => this.setCheckLogin(LoginData));
  }

  setCheckLogin(resdata: any) {
    this.LoginData = resdata;
    if (this.LoginData.GetEmployeeLogin.Result.Status != 'A') {
      this.router.navigate(['/adminlogin']);
    } else {
      this.validsession = this.sesssionvalidator.validate();
      if (this.validsession) {
        this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
        this.shpId = this.userdata?.shipid!;
        this.shipname = this.userdata?.ShipName!;
      } else {
        this.router.navigate(['/shipselect']);
      }
    }
  }

  CruiseDuration() {
    const momentpckgBeg = moment(this.pckgBeg);
    const momentpckgEnd = moment(this.pckgEnd);

    const differenceInDays = momentpckgEnd.diff(momentpckgBeg, 'days');

    return differenceInDays+1;
  }
  
  Day2() {
    const momentpckgBeg = moment(this.pckgBeg);

    const differenceInDays = momentpckgBeg.add(1, 'days').format();

    return differenceInDays;
  }

  Day3() {
    const momentpckgBeg = moment(this.pckgBeg);

    const differenceInDays = momentpckgBeg.add(2, 'days').format();

    return differenceInDays;
  }




}
